import { Inject, Injectable } from '@angular/core';
import { ApiCommonService, TimeApiService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke114aRequest, Sgke114aResponse, Sgke114aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke114aService {

  /**
   * コンストラクタ
   * @param {Sgke114aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @param {TimeApiService} timeApiService
   * @memberof UsedSgke114aService
   */
  constructor(
    public service: Sgke114aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig,
    private timeApiService: TimeApiService
  ) { }

  /**
   * Sgke114aAPI実行
   *
   * @param {Sgke114aRequest} request
   * @return {*}  {Observable<Sgke114aResponse>}
   * @memberof UsedSgke114aService
   */
  public doSgke114a(request: Sgke114aRequest): Observable<Sgke114aResponse> {
    //日付のフォーマットをYYMMDDに変更
    this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);

    return this.service.sgke114aPost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE114A');
          return throwError(err.message);
        })
      );
  }

}

